<template>
  <b-container
    :fluid="fluid"
    class="row-content-wrapper-colored"
    :class="wrapperClass"
  >
    <b-row no-gutters>
      <b-col cols="12" md="12" class="mx-auto px-2 content-container">
        <slot></slot>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "RowContentWrapper",
  props: {
    fluid: { type: Boolean, default: false },
    blue: { type: Boolean, default: false },
  },
  computed: {
    wrapperClass() {
      return {
        'theme-blue': this.blue,
        'theme-default': !this.blue,
      };
    }
  },
};
</script>

<style lang="scss" scoped>
@import "scss/custom.scss";
@import "node_modules/bootstrap/scss/mixins/_breakpoints.scss";

.row-content-wrapper-colored {
  &.theme-blue {
    background-color: #00a0d0;
    color: #ffffff;
  }

  &.theme-default {
    background-color: none;
    color: #393939;
  }
}

.content-container {
  max-width: 2000px;
  padding: 50px 0 60px;

  @include media-breakpoint-down(sm) {
    padding: 30px 0 20px;
  }
}
</style>
